<script lang="ts">
  import {whiteLabeling} from 'Store/WhiteLabelStore';
  import Arrow from 'Components/Common/icons/NextArrow.svelte';
  import {deal} from 'Store/InvestorFlowStore';

  export let disabled: boolean = true;

  $: primaryColorSubmit = $deal.feature_flags.generative_themed_checkout
    ? 'var(--palettes-brand-color-500)'
    : ($whiteLabeling && $whiteLabeling.primary_color) || '#29a39b';
</script>

<button
  {disabled}
  id="accept_invitation"
  type="submit"
  data-testId="submit"
  style="--white-label-color: {primaryColorSubmit}; width: 100%;"
>
  <div class="continue-button">
    <div>Continue</div>
    <div class="arrow"><Arrow /></div>
  </div>
</button>

<style lang="postcss">
  button {
    text-transform: capitalize;
    color: var(--dm-text-cta-color, var(--palettes-neutral-0, white));
    background-color: var(--dm-primary-color, var(--white-label-color));
    border: none;
    height: 3rem;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0.25rem;
    margin-top: 1.2rem;
  }

  button:disabled {
    background-color: var(
      --dm-cta-background-color-disabled,
      var(--palettes-neutral-200, grey)
    );
  }

  .continue-button {
    display: flex;
    justify-content: center;

    & .arrow {
      margin-left: 1rem;

      & :global(path) {
        stroke: var(--dm-text-cta-color, var(--palettes-neutral-0, white));
      }
    }
  }
</style>
